<script lang="ts">
	import { t } from '@riva-mono/common';

	import type { UserStore } from '$lib/stores/user';
	import { enhance } from '$app/forms';
	import { checkCardNumber, extractDateYearFromNationalId, formatNationalId } from '$lib/utils';
	import type { SubmitFunction } from '@sveltejs/kit';

	import type { Session, SupabaseClient } from '@supabase/supabase-js';
	import { getContext } from 'svelte';
	import type { ErrorStoreType } from '$lib/stores/errorStore';
	import { loadCompleteUser } from '$lib/database/manager';
	import Container from '$lib/components/App/Container.svelte';

	interface Props {
		session: Session | null;
		supabase: SupabaseClient;
		closeCallback: () => void;
	}

	let { session, supabase, closeCallback }: Props = $props();

	const userStore: UserStore = getContext('user');
	const errorStore: ErrorStoreType = getContext('error');
	let isLoading = $state(false);

	// const handleNationalIdInput: FormEventHandler<HTMLInputElement> = (e: Event) => {
	// 	const target = e.target as HTMLInputElement;
	// 	target.value = formatNationalId(target.value);
	// };

	const handlePost: SubmitFunction = ({ formData, cancel }) => {
		isLoading = true;

		// const niss = formData.get('niss') as string;
		// if (niss === null) {
		// 	cancel();
		// }

		// const checkNiss = niss ? extractDateYearFromNationalId(niss) : null;
		// if (checkNiss === null || !checkNiss.valid) {
		// 	cancel();
		// 	errorStore.setError({ description: $t('common.invalid_national_id') });
		// 	isLoading = false;
		// }

		// const idCardNumber = checkCardNumber(formData.get('idCardNumber') as string);
		// if (idCardNumber === false) {
		// 	cancel();
		// 	errorStore.setError({ description: $t('common.invalid_id_card') });
		// 	isLoading = false;
		// }

		return async ({ result, update }) => {
			isLoading = false;
			if (result.type === 'error') {
				errorStore.setError({ description: "We couldn't save your profile" });
				return;
			} else if (result.type === 'success') {
				window.sessionStorage.setItem('user', '');
				await loadCompleteUser(supabase, session!, userStore);
			}
			update({ reset: false });
			closeCallback();
		};
	};
</script>

<div style="background:var(--white); ">
	<Container style="animation:unset; padding: 2rem;">
		<h3 style="margin:0; font-size:2em;">{$t('common.profile.title')}</h3>
		{#if $userStore.is_practitioner}
			<strong>Practitioner</strong>
		{/if}
		<form method="POST" action="/api/profile?" use:enhance={handlePost}>
			<!-- Stupid hack to prevent auto focus on first input field on mobile, opening the keyboard -->
			<button tabindex="0" style="opacity:0; position:absolute;" aria-label="hack"></button>
			<div class="col gap-m" style="min-width:unset;">
				<!-- <div class="flex-row space-between" style="flex-wrap:wrap;">
					{$t('common.profile.language')}
					<LanguageDropdown theme="dark" />
				</div> -->
				<div class="flex-row space-between" style="flex-wrap:wrap;">
					<span class="label">{$t('common.profile.firstName')}</span>
					<input tabindex="0" name="firstName" type="text" bind:value={$userStore.first_name} />
				</div>
				<div class="flex-row space-between">
					<span class="label">{$t('common.profile.lastName')}</span>
					<input name="lastName" type="text" bind:value={$userStore.last_name} />
				</div>
				<div class="flex-row space-between">
					<span class="label">{$t('common.profile.sex')}</span>
					<select name="gender" bind:value={$userStore.gender}>
						<option value="male">{$t('common.profile.sexMale')}</option>
						<option value="female">{$t('common.profile.sexFemale')}</option>
						<option value="unknown">{$t('common.profile.sexOther')}</option>
					</select>
				</div>
				<div class="flex-row space-between">
					<span class="label">{$t('common.profile.email')}</span>
					<input name="email" type="text" bind:value={$userStore.email} />
				</div>

				<div class="flex-row space-between">
					<span class="label">{$t('common.profile.phoneNumber')}</span>
					<input type="text" bind:value={$userStore.phone} readonly style="opacity:0.6;" />
				</div>

				<!-- <div class="flex-row space-between">
					<span class="label">{$t('common.profile.niss')}</span>
					<input
						name="niss"
						type="text"
						on:input={handleNationalIdInput}
						bind:value={$userStore.niss}
					/>
				</div> -->

				<!-- <div class="flex-row space-between">
					<span class="label">{$t('common.profile.niss')}</span>
					<input name="idCardNumber" type="text" bind:value={$userStore.idCardNumber} />
				</div> -->

				<button
					class="button primary"
					disabled={isLoading}
					style={isLoading ? 'opacity:0.6; pointer-events:none;' : ''}
				>
					{$t('common.profile.save')}
				</button>
			</div>
		</form>
	</Container>
</div>

<style>
	form {
		border-radius: 1rem;
		width: 100%;
	}

	select,
	input {
		font-size: 0.9em;
		padding: 0.25rem 0.5rem;
		border-radius: 0.5rem;
		border: 1px solid var(--primary-color-10);
		flex: 1;
		width: 100%;
	}

	.label {
		flex: 1;
	}
</style>
